const packageJson = require('../../package.json');

export const environment = {
  appName: 'my eJob',
  production: false,
  test: true,
  version: packageJson.version + ' STAGING',
  i18nPrefix: '',
  apiBaseUrl: '/api/',
  routerTrace: false,
  latDefault: 44.13876,
  lngDefault: 12.23912,
  aadClientId: '51de6e3b-26fc-4a48-9ba6-99b6977eada8',
  aadB2cName: 'myejobstaging',
  expiringDaysInterval: 90,
};
